/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  codigoFicha: string;
  idUnidade: string;
  idLeadCorretor: string;
}
export function useGetCodigoFicha(props: Props) {
  const searchParams = new URLSearchParams();

  if (props.codigoFicha) searchParams.append("numeroFicha", props.codigoFicha);
  if (props.idUnidade) searchParams.append("idUnidade", props.idUnidade);
  if (props.idLeadCorretor)
    searchParams.append("idLeadCorretor", props.idLeadCorretor);

  const GET_FICHA = `${backofficeEnviroment}/common/oportunidades-lead/ficha/v1?${searchParams.toString()}`;
  const fetchData = async () => {
    const response = await instance.get(GET_FICHA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: [
      "get-ficha",
      props.codigoFicha,
      props.idUnidade,
      props.idLeadCorretor,
    ],
    retry: 2,
    refetchOnWindowFocus: false,
    enabled: false,
    onSuccess: () => {
      toast.success("Ficha encontrada com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao buscar ficha. Motivos: ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
